import VueCookies from 'vue-cookies'
import type { VueCookies as VueCookieType } from 'vue-cookies'

import { useAppStore } from '@/store/app'

export function useAppCookies() {
  const appStore = useAppStore()
  const cookies = VueCookies as unknown as VueCookieType // intermeidate unkown to handle ts type casting mismatch

  const getCookies = (key: string) => {
    return cookies.get(key)
  }

  const setCookies = (key: string, value: string): VueCookieType => {
    return cookies.set(
      key,
      value,
      undefined,
      undefined,
      appStore.getPortalDomain
    )
  }

  const removeCookies = (key: string, path?: string): boolean => {
    return cookies.remove(key, path, appStore.getPortalDomain as string)
  }

  return { cookies, getCookies, setCookies, removeCookies }
}
